import React, { ReactNode, useState } from "react";
import ResponsiveModalAbsolute from "../../../../components/ResponsiveModalAbsolute";
import { fetchAxiosToken } from "../../../../helpers/fetchAxiosToken";
import { useAppSelector } from "../../../../hooks/hooks";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import dividirFechaDatePicker from "../../../../helpers/dividirFechaDatePicker";
import { InputDate } from "../../../../components/InputDate";
import { useParams } from "react-router-dom";

interface Input {
    id_casa?: number | null;
    id_habitacion?: number | null;
    rango_inicio: string;
    rango_final: string;
    precio: string;
    tipo: string;
    fecha_inicio: string;
    fecha_final: string;
}

interface ModalProps {
    modalVisible: boolean;
    setModalVisible: (visible: boolean) => void;
}

type errorObject = { [key: string]: string };

export const ModalNewPeople = ({
    modalVisible,
    setModalVisible,
}: ModalProps) => {
    const { idCasa } = useParams();
    registerLocale("es", es);
    const { tipo_usuario } = useAppSelector((state) => state.usuario_logeado);
    const {
        id: id_casa,
        tipo_moneda,
        plan,
    } = useAppSelector((state) => state.landing_house.house);

    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState<Input>({
        id_casa: id_casa,
        id_habitacion: idCasa ? Number(idCasa) : null,
        rango_inicio: "",
        rango_final: "",
        precio: "",
        tipo: "Siempre",
        fecha_inicio: "",
        fecha_final: "",
    });

    const handleSubmit = async () => {
        if (input.precio === "") {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error",
                text: "Debes agregar un precio adicional ",
                icon: "error",
                confirmButtonText: "Ok",
            });

            return;
        }

        if (input.rango_inicio === "" || input.rango_final === "") {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error",
                text: "Debes agregar la cantidad de personas (Desde y Hasta) ",
                icon: "error",
                confirmButtonText: "Ok",
            });

            return;
        }

        if (
            input.tipo === "Fecha" &&
            (input.fecha_inicio === "" || input.fecha_final === "")
        ) {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error",
                text: "Debes agregar el rango de fechas",
                icon: "error",
                confirmButtonText: "Ok",
            });

            return;
        }

        try {
            setLoading(true);

            if (
                tipo_usuario === 3 ||
                tipo_usuario === 4 ||
                tipo_usuario === 6
            ) {
                await fetchAxiosToken({
                    url: `/personas_adicionales`,
                    body: {
                        ...input,
                        rango_inicio: Number(input.rango_inicio),
                        rango_final: Number(input.rango_final),
                    },
                    method: "post",
                });
            }

            if (tipo_usuario === 8) {
                await fetchAxiosToken({
                    url: `/personas_adicionales_habitaciones`,
                    body: {
                        ...input,
                        rango_inicio: Number(input.rango_inicio),
                        rango_final: Number(input.rango_final),
                    },
                    method: "post",
                });
            }

            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Creado con exito",

                icon: "success",
                confirmButtonText: "Ok",
            });
            setModalVisible(false);
            setLoading(false);
        } catch (error: any) {
            console.log(error);
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error",
                text: `${error.response.data.error}`,
                icon: "error",
                confirmButtonText: "Ok",
            });
            setLoading(false);
        }
    };

    return (
        <ResponsiveModalAbsolute
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
        >
            <h1 className="text-base font-medium text-center 2xl:text-lg">
                Crear personas adicionales
            </h1>
            <div className="flex flex-col max-w-md gap-4 p-4 mx-auto ">
                <div className="flex flex-col items-center justify-center">
                    <div className="w-full">
                        <label className="text-base font-medium 2xl:text-lg ">
                            Por:
                        </label>
                        <select
                            name="tipo_estadia"
                            onChange={(e) =>
                                setInput({
                                    ...input,
                                    tipo: e.target.value,
                                })
                            }
                            className="w-8/12 ml-2  pl-1 xs:px-4 rounded-lg 2xl:py-2 py-1.5 2xl:text-base text-sm bg-transparent border border-[#E9E9E9] outline-none focus:outline-none placeholder:text-gray-400 cursor-pointer"
                            value={input.tipo}
                        >
                            <option value="Siempre">Siempre</option>
                            <option value="Fecha">Fecha</option>
                        </select>
                    </div>

                    {input.tipo === "Fecha" && (
                        <>
                            <hr className="w-full my-4 bg-gray-300" />
                            <div className="w-full">
                                <div className="text-sm font-medium text-left 2xl:text-base">
                                    Fechas
                                </div>
                                <div className="flex items-center w-full mt-2 text-sm 2xl:text-base">
                                    <label className="text-base font-medium 2xl:text-lg ">
                                        Inicial:
                                    </label>
                                    <InputDate
                                        className="w-8/12 p-2 ml-6 bg-white border rounded-lg cursor-pointer 2xl:py-2 py-1.5 2xl:text-base text-sm"
                                        selectedDay={input.fecha_inicio}
                                        placeholderText="Seleccionar fecha"
                                        onChange={(date) =>
                                            setInput({
                                                ...input,
                                                fecha_inicio: date ? date : "",
                                            })
                                        }
                                    />
                                </div>
                                <div className="flex items-center w-full mt-2">
                                    <label className="mr-2 text-base font-medium 2xl:text-lg">
                                        Final:
                                    </label>

                                    <InputDate
                                        className="w-8/12 p-2 ml-6 bg-white border rounded-lg cursor-pointer 2xl:py-2 py-1.5 2xl:text-base text-sm"
                                        selectedDay={input.fecha_final}
                                        placeholderText="Seleccionar fecha"
                                        onChange={(date) =>
                                            setInput({
                                                ...input,
                                                fecha_final: date ? date : "",
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    <hr className="w-full my-4 bg-gray-300" />
                    <div className="w-full">
                        <div className="text-sm font-medium text-left 2xl:text-base">
                            Cantidad de personas
                        </div>
                        <div className="flex items-center w-full mt-2">
                            <label className="text-base font-medium 2xl:text-lg ">
                                Desde:
                            </label>
                            <input
                                type="number"
                                placeholder="Personas"
                                onChange={(e) =>
                                    setInput({
                                        ...input,
                                        rango_inicio: e.target.value,
                                    })
                                }
                                className=" w-20 xs:w-24 ml-2 pl-[1px]  xs:px-2 rounded-lg 2xl:py-2 py-1.5 2xl:text-base text-sm bg-transparent border border-[#E9E9E9] outline-none focus:outline-none placeholder:text-gray-400"
                                value={input.rango_inicio}
                            />
                            <label className="ml-2 text-base font-medium 2xl:text-lg ">
                                Hasta:
                            </label>
                            <input
                                type="number"
                                placeholder="Personas"
                                onChange={(e) =>
                                    setInput({
                                        ...input,
                                        rango_final: e.target.value,
                                    })
                                }
                                className="  w-20 xs:w-24 ml-2 pl-[1px] xs:px-2 rounded-lg 2xl:py-2 py-1.5 2xl:text-base text-sm bg-transparent border border-[#E9E9E9] outline-none focus:outline-none placeholder:text-gray-400"
                                value={input.rango_final}
                            />
                        </div>
                    </div>

                    <hr className="w-full my-4 bg-gray-300" />
                    <div className="w-full">
                        <h2 className="text-sm font-medium text-left 2xl:text-base">
                            Costo
                        </h2>
                        <div className="items-center w-full mt-2 text-sm xs:flex 2xl:text-base">
                            <label className="font-medium ">
                                Precio adicional por noche ({tipo_moneda}):
                            </label>
                            <input
                                type="number"
                                placeholder="50"
                                onChange={(e) =>
                                    setInput({
                                        ...input,
                                        precio: e.target.value,
                                    })
                                }
                                className=" w-8/12 xs:w-16 mt-1 xs:ml-2 px-2 rounded-lg 2xl:py-2 py-1.5 2xl:text-base text-sm bg-transparent border border-[#E9E9E9] outline-none focus:outline-none placeholder:text-gray-400"
                                value={input.precio}
                            />
                        </div>
                    </div>
                </div>

                <button
                    disabled={loading}
                    onClick={() => handleSubmit()}
                    className="p-3 mt-6 font-medium text-white border rounded-lg bg-[#029BFC] active:translate-y-1 disabled:translate-y-0 disabled:from-slate-400 disabled:to-gray-400 disabled:cursor-not-allowed 2xl:text-base text-sm"
                >
                    Crear personas adicionales
                </button>
            </div>
        </ResponsiveModalAbsolute>
    );
};
